<template>
  <div class="table-box">
    <mf-loading :loader="['last-update', 'primeiro-registro', 'produtos-mais-faturados-top']" loader-type="table">
      <v-container fluid grid-list-md>
        <v-layout>
          <v-flex v-for="(card, index) in cards" :key="index" xs4>
            <cbm-card
              :number-text="card.value"
              :title="card.text"
              :loader="card.loader"
              use-loader
              :percent-text="card.underText"
              :is-currency="card.isCurrency"
              unset-percentage-colors
              simple-card
            />
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table :headers="headers" :items="dadosTabela" hide-default-footer disable-pagination @current-items="updateSelectedItems">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.index }}</td>
            <td>
              <router-link class="link" :to="{ path: `/produtos/detalhes-produto/${item['COD_ID_PRODUTO']}` }">
                {{ item['COD_ID_PRODUTO'] }} - {{ item['DES_PRODUTO'] }}
              </router-link>
            </td>
            <td class="text-right">{{ item['NUM_CUPONS_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
            <td class="text-right">{{ item['NUM_CLIENTES_TOTAL'] | localeString }}</td>
            <td class="text-right">{{ item['VAL_QUANTIDADE_KG_TOTAL'] | localeString(1) }}</td>
            <td class="text-right">{{ item['PORCENTAGEM'] | localeString(1) | percent }}</td>
          </tr>
        </template>
      </v-data-table>
    </mf-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { porcentagemProduto, localeString } from '@/config/helpers.js'
import CbmCard from '@/components/CbmCard.vue'
import cloneDeep from 'lodash/cloneDeep'
import floor from 'lodash/floor'
import { mapWaitingActions } from 'vue-wait'
import { productRanking } from '@/modules/produtos/ranking-produtos/mixins/productRanking'

export default {
  components: {
    CbmCard,
  },
  mixins: [productRanking],
  computed: {
    ...mapGetters(['produtosTopMaisFaturados', 'produtosSkuAtivasFaturamento', 'produtosTotalFaturamento', 'produtosTotalTopFaturados']),
    dadosTabela() {
      return cloneDeep(this.produtosTopMaisFaturados).map((object, index) => {
        object['PORCENTAGEM'] = porcentagemProduto(object['VAL_FATURAMENTO_TOTAL'], this.produtosTotalFaturamento)
        object.index = index + 1
        return object
      })
    },
    topFaturadosPorcentagem() {
      return `${floor((this.produtosTotalTopFaturados / this.produtosTotalFaturamento) * 100, 1)} %`
    },
    cards() {
      return [
        {
          text: 'Total de faturamento',
          value: localeString(this.produtosTotalFaturamento || 0, 0),
          isCurrency: true,
          loader: 'totais-faturamento-produtos',
        },
        {
          text: 'Faturamento dos 100 itens com maior faturamento',
          value: localeString(this.produtosTotalTopFaturados || 0, 0),
          underText: this.topFaturadosPorcentagem,
          isCurrency: true,
          loader: 'totais-faturamento-produtos-top',
        },
        {
          text: 'Produtos distintos vendidos no período',
          value: localeString(this.produtosSkuAtivasFaturamento || 0, 0),
          loader: 'totais-faturamento-produtos',
          isInteger: true,
        },
      ]
    },
  },
  methods: {
    ...mapWaitingActions({
      totaisFaturamentoProdutos: 'totais-faturamento-produtos',
      totaisFaturamentoProdutosTop: 'totais-faturamento-produtos-top',
      produtosMaisFaturadosTop: 'produtos-mais-faturados-top',
    }),
    internalGetData(filter) {
      return [this.totaisFaturamentoProdutos(filter), this.totaisFaturamentoProdutosTop(filter), this.produtosMaisFaturadosTop(filter)]
    },
  },
}
</script>
